import { useState, type FormEvent } from "react";
import { useSupabaseAuth } from "./useSupabaseAuth";
import { CtaButton } from "../../components/ui/Button";

export function LoginForm() {
  const { signIn } = useSupabaseAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signIn(email, password);
    } catch {
      setError("Email o contraseña incorrectos.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-[60] mx-auto flex max-w-[430px] flex-col items-center justify-center gap-4 px-6"
      style={{
        background:
          "radial-gradient(600px 400px at 50% 18%, rgba(46,107,255,.16), transparent 65%), #05070D",
      }}
    >
      <div
        className="mb-2 grid h-16 w-16 place-items-center rounded-card font-display text-2xl font-extrabold text-white"
        style={{
          background: "linear-gradient(160deg,#3F7BFF,#2E6BFF)",
          boxShadow: "0 10px 40px rgba(46,107,255,.45), inset 0 1px 0 rgba(255,255,255,.25)",
        }}
      >
        VF
      </div>
      <form onSubmit={handleSubmit} className="w-full max-w-[280px]">
        <input
          type="email"
          required
          autoFocus
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-3 w-full rounded-inner border border-line bg-white/[.045] px-4 py-3 font-body text-[14.5px] text-text outline-none focus:border-accent"
        />
        <input
          type="password"
          required
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-3 w-full rounded-inner border border-line bg-white/[.045] px-4 py-3 font-body text-[14.5px] text-text outline-none focus:border-accent"
        />
        {error && <p className="mb-2 font-mono text-[11px] text-red-400">{error}</p>}
        <CtaButton type="submit" disabled={loading}>
          {loading ? "Entrando…" : "Entrar"}
        </CtaButton>
      </form>
    </div>
  );
}
